export default "__VITE_ASSET__7e3cbb28__"